import { render, staticRenderFns } from "./ImportScreen.vue?vue&type=template&id=4b8dd7e3&"
import script from "./ImportScreen.vue?vue&type=script&lang=js&"
export * from "./ImportScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8dd7e3')) {
      api.createRecord('4b8dd7e3', component.options)
    } else {
      api.reload('4b8dd7e3', component.options)
    }
    module.hot.accept("./ImportScreen.vue?vue&type=template&id=4b8dd7e3&", function () {
      api.rerender('4b8dd7e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/Settings/ImportScreen.vue"
export default component.exports